import React from "react"
import Chip from "../../../../common/chip/Chip"

const modalManageUserId = 'msync-modal-member-manage-user'
const modalConfirmationMessageId = 'msync-modal-member-confirmation-message'
const modalMembersTblBtnId = {
  demoteToMember: {
    title:  'Demote to Member',
    request: 'msync_member_set_as_member',
    content: 'Demoting this user from manager to member will remove their management capabilities. They will no longer be able to invite or remove other users.'  
  },
  setAsManager: {
    title: 'Set as Manager',
    request: 'msync_member_set_as_manager',
    content: "Are you sure you'd like to apply management permissions to this user? Managers can add and remove users. Confirm your choice to proceed."
  },
  deleteUser: {
    title: 'Delete User',
    request: 'msync_member_delete_user',
    content: 'Are you sure you want to delete this user? This action cannot be undone, and all associated data will be permanently removed.'
  } 
} 

const handleMembersConfirmationModal = ( id, info, hasModal = null, setSelectedUser, setSelectedModal, teamType = 'wooteams' ) => {

  if( ! id || ! info ) return null
  setSelectedModal( '' )

  if( hasModal !== null ){
    MicroModal.close( hasModal )
    setSelectedModal( hasModal )
  }
  info.teamType = teamType
  setSelectedUser( info )
  MicroModal.show( id )
  
}

const titleCase = ( word ) => {
  return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
}

const UserBadge = ({ role = '——', className }) => {
  let type = '';
  const roleLowerCase = role.toLocaleLowerCase();

  switch (roleLowerCase) {
    case 'owner':
      type = 'success';
      break;
    case 'member':
      type = 'primary';
      break;
    case 'manager':
      type = 'secondary';
      break;
    default:
      type = 'default';
      break;
  }

  return (
    <Chip type={type} className={className}>
      {titleCase(role)}
    </Chip>
  );
};

const notAllowedUserMembershipStatus = ['wcm-cancelled', 'wcm-paused', 'wcm-failed', 'wcm-expired']

export{
  UserBadge,
  notAllowedUserMembershipStatus,
  modalMembersTblBtnId,
  modalManageUserId,
  modalConfirmationMessageId,
  handleMembersConfirmationModal
}
